import { render, staticRenderFns } from "./ModuleFood.vue?vue&type=template&id=2079d8a6&"
import script from "./ModuleFood.vue?vue&type=script&lang=js&"
export * from "./ModuleFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports